// 督办单
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :showSaveBtn="showSaveBtn" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid v-if="showTable" show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="handleAdd" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(null, true)">新增
                  </vxe-button>
                  <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog(null, true)">批量导入
                  </vxe-button> -->
<!--                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"-->
<!--                              @click="openEditDialog(null, true)">批量导出-->
<!--                  </vxe-button>-->
                </div>
                <div class="fr" style="display: flex;">
                  <el-input placeholder="请输入督办单号" style="width: 200px;     height: 27px !important;"
                            v-model="formData.searchValue" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" style="width: 100%"
                          title-align="right" :data="formData" @submit="searchEvent" @reset="searchEvent">

                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input placeholder="请输入工单号" style="width: 200px;     height: 27px !important;"
                                v-model="requestParam.orderNo" clearable>
                      </el-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="督办对象:" field="name">
                    <template v-slot>
                      <el-autocomplete
                        class="inline-input"
                        style="width:11vw ;"
                        v-model="requestParam.handlerName"
                        :fetch-suggestions="querySiteSearch"
                        placeholder="请输入内容"
                        :trigger-on-focus="false"
                        @select="handleSiteSelect"
                      />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="督办事项:" field="name">
                    <template v-slot>
                      <el-select v-model="requestParam.handleMatter"  clearable style="width:11vw ;">
                        <el-option v-for="item in sysDictItemList" :key="item.value" :label="item.label"
                                   :value="item.value"/>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name" style="width:17vw ;">
                    <template v-slot style=" display: inline-block;width:17vw ;">
                      <el-date-picker style="width: 14vw;" v-model="requestParam.createDate" type="daterange" align="right"
                                      unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #option="{row}">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id, true)">
                <el-tooltip :enterable='false' effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                  <i class="el-icon-edit"/>
                </el-tooltip>
              </a>

              <el-dropdown v-if="row.stat==1" @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">审核</el-dropdown-item>
                  <el-dropdown-item command="2">驳回</el-dropdown-item>
                  <el-dropdown-item command="3">作废</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
        <span>{{dialogMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
         <!-- /督办人弹框 -->
         <duDialog v-if="showDbDialog" @commitAdminRow="commitAdminRow"
      :visiable.sync="showDbDialog" multi="true" />
  </div>
</template>

<script>
import editView from './edit.vue';
import preconditionDialog from './dialog';
import preconditionDialog2 from './dialog2.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
// 督办人弹框
import duDialog from "@/views/dialogCommon/adminDialog";
import {dictType, loadDictData} from "@/config/dictType";

export default {
  name: 'list',

  inject: ['reload'],
  components: {editView, pager, preconditionDialog, preconditionDialog2,
    // 督办人弹框
    duDialog,},
  data() {
    return {
         // 督办人弹框
         showDbDialog: false,
      total: 0,
      showTable: false,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        tabStat: '待督办',
        stat: 0,
        createDateBegin: null,
        createDateEnd: null,
        handlerId: null,
        handlerName: null,
        orderNo:null,
        searchValue:"",
        handleMatter:""
      },
      formData: {
        searchValue:"",
        stat: "待督办",
        orgId: null,
        siteId: null,
        createDate: null,
        handlerId: null,
        handlerName: null,
        orderNo:null
      },
      siteName: null,
      showStatOption: false,
      showSaveBtn: false,
      dialogVisible: false,
      showMoreOptions: false,
      sitePromptList: [],
      sysDictItemList:[],
      goodsStatusList: [ //循环列表
        {statName: "待督办", num: 2},
        {statName: "无法处理", num: 0},
        {statName: "所有", num: 0},
        // {name: "作废", num: 0},
        // {name: "全部", num: 0},

      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      dialogMsg: null,
      currentRow: null,
      stat: 0, // 数据所要切换的状态值

      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {width: 100, field: 'stat', fixed: 'right', title: '操作', showOverflow: true, slots: {default: 'option'}},
        { title: '督办单号', field: 'handleNo', width: 200, slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.handleNo}</span>
              ]
            }
          }
        },   {
          title: '督办状态', field: 'handleStat', width: 125, slots: {
            default: ({row}) => {
              if (row.handleStat == 1) {
                return [
                  <div class="txt-status neutral">
                    <span>待督办</span>
                  </div>
                ];
              } else if (row.handleStat == 3) {
                return [
                  <div class="txt-status ">
                    <span>已处理</span>
                  </div>
                ];
              } else if (row.handleStat == 5) {
                return [
                  <div class="txt-status disable">
                    <span>无法处理</span>
                  </div>
                ];
              } else if (row.handleStat == 9) {
                return [
                  <div class="txt-status disable">
                    <span>关闭</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '督办事项', field: 'handleMatterName', width: 150,},
        {title: '督办对象', field: 'handlerName', width: 160,},
        {title: '督办时间', field: 'handleTime', width: 150,},
        {title: '创建人', field: 'createBy', width: 80,},
        {title: '创建时间', field: 'createTime', width: 150,},

      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    siteName(n) {
      if (!n) {
        this.formData.siteId = null
      }
    }
  },
  created() {
    this.handleAdd = this.permissions["handleAdd"];
  },

  mounted() {
    this.initSearchDate()
    this.loadTabOption()
    this.loadDictData()
  },

  methods: {
        //确定选择督办人
        commitAdminRow(data){
      // this.order.managerId = data.id;
      this.formData.orgId = data.username;
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },
    confirm() {
      this.$http({
        url: api.sfSiteFinflow.confirmDataUrl,
        method: 'post',
        data: {
          id: this.currentRow.id,
          stat: this.stat
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.flushed()
      })
      this.dialogVisible = false
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.soOrderHandle.getCountUrl,
        method: 'post',
        data: {}
      }).then(res => {
        let data = res.data.data
        this.goodsStatusList = data
        if (data != null && data.length > 0) {
          this.formData.stat = data[0].stat
          this.requestParam.stat = data[0].stat
        }
        this.showTable = true
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.requestParam.tabStat = this.goodsStatusItem
      this.flushed()
    },


    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soOrderHandle.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      let formData = this.formData

      this.requestParam.stat = formData.stat
      this.requestParam.orgId = formData.orgId
      this.requestParam.siteId = formData.siteId
      this.requestParam.searchValue = formData.searchValue

      if (formData.createDate !== null && formData.length !== 0) {
        this.requestParam.createDateBegin = formData.createDate[0]
        this.requestParam.createDateEnd = formData.createDate[1]
      }


      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 加载数据字典中的督办事项
    loadDictData() {
      // 物流公司
      loadDictData(dictType.handleMatter).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.sysDictItemList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    // 打开弹窗
    handleCommand(command, row) {
      this.currentRow = row
      console.log(command, row, "command, row");
      if (command == 1) {
        this.dialogMsg = '确定审核吗？'
        this.stat = 2
        this.dialogVisible = true
      } else if (command == 2) {
        this.dialogMsg = '确定驳回吗？'
        this.stat = 3
        this.dialogVisible = true
      } else if (command == 3) {
        this.dialogMsg = '确定作废吗？'
        this.stat = 99
        this.dialogVisible = true
      }
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id, false);
      console.log(row, id, "row");
    },
    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },

    // 打开执行考核弹窗
    handleCommand2(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    // 新增
    openEditDialog(id, flag) {
      this.showSaveBtn = flag
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏


::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
  display: inline-block;
  width: 21%;
}

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
